import styled, { css } from 'styled-components'
import Mixin from 'components/common/Mixin'
import Media from 'components/common/Media'
import { H2 } from 'components/common/Text/Text'
import Icon from 'components/common/Icon/Icon'
import Drawer from 'components/common/Drawer'

export const Column = styled.div`
  ${props => props.responsive && css`
    ${Media.desktop`
      display: inline-block;
      width: 50%;
      vertical-align: top;
    `}
  `}
  ${props => props.half && css`
    display: inline-block;
    width: 50%;
    vertical-align: top;
  `}
  ${props => props.centered && css`
    text-align: center;
  `}
  ${Media.desktop`
    padding: ${props => props.padding_desktop || '0'};
  `}
  ${Media.mobile`
    padding: ${props => props.padding_mobile || '0'};
  `}
  margin: ${props => props.margin || '0'};
`

export const Title = styled(H2).attrs({
  'data-at-tire-line-title': true
})`
  font-size: 20px;
  ${Mixin.responsive('margin', '40px 0 28px', '30px 0 28px')}
`

export const SubTitle = styled.h3.attrs({
  'data-at-tire-line-subtitle': true
})`
  position: relative;
  width: 288px;
  text-transform: uppercase;
  ${Mixin.font.GothamBold(16, 600, 20)}
  ${Mixin.responsive('margin', '0 0 30px', '0 0 20px')}
`

export const Circle = styled(Icon).attrs({
  'data-at-tire-line-subtitle-icon': true
})`
  position: absolute;
  top: 10px;
  ${Mixin.responsive('right', '-15px', '1px')}
`

export const IncompatibleDrawer = styled(Drawer)`
  ${Media.mobile`
    margin: 0 -16px;
  `}
`
